<script setup>
  import { ref, computed, onMounted, getCurrentInstance } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import _ from 'lodash';
  import moment from "moment";
  import { usePageLoadingStore } from "../../../../../stores/pageLoading";
  import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
  import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
  import mypageJobFairService from '../../../../user/services/mypage/jobFair/mypageJobFairService';
  import adminJobfairStateService from '../../../services/jobfair/adminJobfairStateService';
  import JobFairJobNoticeDetailModal from '../../../../user/components/modal/jobFair/JobFairJobNoticeDetailModal.vue';
  import JobFairResumeDetailModal from '../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue';

  const route = useRoute()
  const router = useRouter()
  const loadingStore = usePageLoadingStore()
  const { $pageListBoardNo, $toast, $interests, $intvGb, $userIntvStateGb, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const searchOpen = ref(true);
  const list = ref([]);

  const data_interests = ref([...$interests]); // 관심 카테고리
  const data_intvGb = ref([...$intvGb]); // 면접방식
  const data_userIntvStateGb = ref($userIntvStateGb); // 사용자면접제안상태

  const jobNoticeModal = ref(null);
  const jobFairResumeModal = ref(null);

  // 검색
  const searchTypeRef = ref(null);
  const interestsListRef = ref(null);
  const intvPropStateGbsListRef = ref(null);
  const intvsListRef = ref(null);

  // 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
  const searchDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
  ])

  const pageSizeGroup = ref([
    { label:"10개씩 보기", value: 10 },
    { label:"30개씩 보기", value: 30 },
    { label:"50개씩 보기", value: 50 },
    { label:"100개씩 보기", value: 100 },
  ])

  // text 검색. tab 마다 항목 다름.
  const searchTypeGroup = ref([
    { label:"이름", value: "applicantName", placeholder: "이름을 입력해주세요."  },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"마스터 이름", value: "name", placeholder: "마스터 이름을 입력해주세요."  },
    { label:"채용공고 제목", value: "jTitle", placeholder: "채용공고 제목을 입력해주세요."  },
  ]);

  const initSearchInputModel = { // 학생/취업준비생(2) - 받은 면접제안(4)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchIntvPropStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchIntvGbs: ['01', '02', '03', '04'],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'applicantName', // applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목
    searchInput: '',
  };

  const searchInput = ref({...initSearchInputModel});

  // 검색 - searchType 셀렉트 박스 선택시
  const onSelectSearchTypeGroup = (option) => {
    searchInput.value.searchType = option.value;
  }

  const searchInputPlaceholder = computed(()=>{
    const option = _.find(searchTypeGroup.value, { value: searchInput.value.searchType });
    if(option) {
      return option.placeholder;
    } else {
      return '';
    }
  })

  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 페이지당 개수 변경
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  const retrieveList = () => {
    const now = new Date();
    const startYmd = searchInput.value.startYmd ? searchInput.value.startYmd : moment(now).format('YYYYMMDD');
    const endYmd = searchInput.value.endYmd ? searchInput.value.endYmd : moment(new Date(now.setDate(now.getDate() + 30))).format('YYYYMMDD');

    const paramObj = {
      searchInterests: _.map(searchInput.value.searchInterests).join(','),
      searchIntvPropStateGbs: _.map(searchInput.value.searchIntvPropStateGbs).join(','),
      searchIntvGbs: _.map(searchInput.value.searchIntvGbs).join(','),
      startYmd: searchInput.value.searchDurationType === 'all' ? '' : startYmd,
      endYmd: searchInput.value.searchDurationType === 'all' ? '' : endYmd,
      searchType: searchInput.value.searchType,
      searchInput: searchInput.value.searchInput,
      pageNumber: currentPage.value,
      size: pageSize.value,
    };

    loadingStore.loading = true;
    adminJobfairStateService.retrieveReceivedInterviewProposalEntryListPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
      });
  };

  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  }

  const clearSearchInput = () => {
    searchInput.value = {...initSearchInputModel};

    interestsListRef.value?.initOptions();
    intvPropStateGbsListRef.value?.initOptions();
    intvsListRef.value?.initOptions();
    searchTypeRef.value?.initSelectedOption('applicantName');
  }
    
  // 이력서 보기
  const onClickMyResume = async (resumeId, delYn) => {
    if (delYn === 'Y') {
      alert(["삭제된 이력서 입니다."]);
    } else {
      await jobFairResumeModal.value.show({
        resumeId,
        showDeleteBtn: false,
      });
    }
  }

  // 채용공고 보기
  const onClickJobNotice = async (jobNoticeSeq, corpId) => {
    await jobNoticeModal.value.show({
      jobNoticeSeq,
      corpId,
    });
  }
    
  // 받은 면접제안 상태변경
  const onClickIntvPropState = async (row, stateGb) => {
    let modalContent, okButtonText;
    if (stateGb === '02') {
      modalContent = ["면접 제안을 수락하시겠습니까?", "'제안수락'으로 상태가 변경됩니다."];
      okButtonText = "제안 수락";
    } else {
      modalContent = ["면접 제안을 거절하시겠습니까?", "'제안거절'로 상태가 변경됩니다."];
      okButtonText = "제안 거절";
    }
    const ok = await confirm(modalContent, okButtonText);
    if(ok) {
      const paramObj = {
        jobNoticeSeq: row.jobNoticeSeq,
        resumeId: row.resumeId,
        intvPropStateGb: stateGb
      };

      mypageJobFairService.updateIntvPropStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            alert('변경하였습니다.');
            retrieveList();
          } else {
            alert('변경을 실패하였습니다.');
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          alert('변경을 실패하였습니다.');
        });
    }
  }

  const openDetailInNewTab = (linkName, id, query = {}) => {
    const url = router.resolve({
      name: linkName,
      params: { id },
      query,
    }).href;

    window.open(url, '_blank');
  }

  onMounted(() => {
    retrieveList();
  })
</script>

<template>
  <div>
    <!-- s: 검색 -->
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
          <dd>
            <KSACheckBoxGroup
              ref="interestsListRef"
              className="mr-md"
              name="interestsList"
              v-model="searchInput.searchInterests"
              :options="data_interests"
            />
          </dd>
        </dl>
        <dl>
          <dt style="display:block;">상태</dt>
          <dd>
            <KSACheckBoxGroup
              ref="intvPropStateGbsListRef"
              className="mr-md"
              name="intvPropStateGbsList"
              v-model="searchInput.searchIntvPropStateGbs"
              :options="data_userIntvStateGb"
            />
          </dd>
        </dl>
        <dl>
          <dt>면접 방식</dt>
          <dd>
            <KSACheckBoxGroup
              ref="intvsListRef"
              className="mr-md"
              name="intvsList"
              v-model="searchInput.searchIntvGbs"
              :options="data_intvGb"
            />
          </dd>
        </dl>
        <dl>
          <dt>제안 받은일</dt>
          <dd class="text-box">
            <div class="grid">
              <template v-for="group in searchDurationTypeGroup" key="group.value" >
                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
              </template>
              <div style="display: inline-block;" v-if="searchInput.searchDurationType !== 'all'">
                <KSADatepickerTerms
                  :startDate="searchInput.startYmd"
                  :endDate="searchInput.endYmd"
                  @update:startDate="(value)=> searchInput.startYmd = value"
                  @update:endDate="(value)=> searchInput.endYmd = value"
                />
              </div>
            </div>
          </dd>
        </dl>
        <!-- applicantName 이름, rTitle 이력서 제목, corpName 기업명, name 마스터 이름, jTitle 채용공고 제목 검색 -->
        <dl>
          <dt>
            <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="select" @selectOption="onSelectSearchTypeGroup"/>
          </dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.searchInput" :placeholder="searchInputPlaceholder" />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <!-- e: 검색 -->
    <!-- s: 버튼영역 -->
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount)}}</span>개</p>
      <div>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
      </div>
    </div>
    <!-- e: 버튼영역 -->
    <div class="table-form">
      <table class="horizontal">
        <tr>
          <th>NO</th>
          <th>기업명</th>
          <th>채용공고 제목</th>
          <th>마스터</th>
          <th>관심 카테고리</th>
          <th>면접 방식</th>
          <th>이력서 제목</th>
          <th>이름</th>
          <th>제안 받은일</th>
          <th>상태</th>
          <th>상태변경</th>
        </tr>
        <tr v-for="intvProposal in list">
          <td>{{ intvProposal.boardNo }}</td>
          <td class="clickable blue text-overflow long-overflow">
            <span @click="openDetailInNewTab('CorporationDetail', intvProposal.corpId, { tab: 3, tab2: 'job-postings' })">{{ intvProposal.corpName }}</span>
          </td>
          <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(intvProposal.jobNoticeSeq, intvProposal.corpId)">{{ intvProposal.jobName }}</td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', intvProposal.userId)">{{ intvProposal.userName }}</span>
          </td>
          <td>{{ intvProposal.interests }}</td>
          <td>{{ $gbNameKR("INTV_GB", intvProposal.intvGb) }}</td>  
          <td class="text-overflow long-overflow">
            <span class="file" v-if="intvProposal.fileYn === 'Y'" v-for="resumeAttaches in intvProposal.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
              {{ resumeAttaches.fileName }}
            </span>
            <span class="clickable blue" v-else @click="onClickMyResume(intvProposal.resumeId, intvProposal.delYn)">
              {{ intvProposal.title }}
            </span>
          </td>
          <td class="clickable blue">
            <span  @click="openDetailInNewTab('MemberDetail', intvProposal.applicantId)">{{ intvProposal.applicantName }}</span>
          </td>
          <td>{{ $yyyymmddHHmmss(intvProposal.createDate) }}</td>
          <td>
            <span v-if="intvProposal.intvPropStateGb === '01'">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
            <span v-else-if="intvProposal.intvPropStateGb === '02' || intvProposal.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
            <span v-else-if="intvProposal.intvPropStateGb === '03' || intvProposal.intvPropStateGb === '06'" class="red">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
            <span v-else class="gray">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
          </td>
          <td>
            <div v-if="intvProposal.intvPropStateGb === '01'">
              <KSATextButton text="제안수락" @click="onClickIntvPropState(intvProposal, '02')" class="clickable black"></KSATextButton>
              &nbsp;
              <KSATextButton text="제안거절" @click="onClickIntvPropState(intvProposal, '03')" class="clickable black"></KSATextButton>
            </div>
            <div v-else-if="intvProposal.intvPropStateGb === '02'">
              <KSATextButton text="제안거절" @click="onClickIntvPropState(intvProposal, '03')" class="clickable black"></KSATextButton>
              &nbsp;
            </div>
            <div v-else-if="intvProposal.intvPropStateGb === '03' && intvProposal.delYn !== 'Y'">
              <KSATextButton text="제안수락" @click="onClickIntvPropState(intvProposal, '02')" class="clickable black"></KSATextButton>
              &nbsp;
            </div>
            <div v-else>-</div>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        받은 면접제안 내역이 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
  </div>
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
  <JobFairResumeDetailModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
</template>

<style scoped>
</style>
